// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PkOZ5","index":"styles_index__2LQWd"};